/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState, useContext} from 'react';
import {FluidContainer} from '../../../components';
import {ARMcontext} from '../../../utils/context/context';
//import {Teams} from '../../../utils/api';
import {TablesContainer, TablesWrapper} from './styles';
import {default as ArmSoreness} from './armSoreness/armSoreness';
import {default as Fatigue} from './fatigue/fatigue';
import {default as Workloads} from './scorecardWorkloads/workloads';
import {default as TrainingAccountability} from './trainingAccountability/trainingAccountability';
import {default as ExamAccountability} from './examAccountability/examsAccountability';
import {default as PersonalRecords} from './personalRecords/personalRecords';
import {default as MedicalAlerts} from './medicalAlerts/medicalAlerts';

export default ({playersGroup, playerNameSearch}: {playersGroup: string; playerNameSearch: string}) => {
  const [exams, useExams] = useState<Array<object | any>>([]);
  const {selectedTeam} = useContext(ARMcontext);

  //const TEAMS = new Teams();

  useEffect(() => {
    getScorecardData();
  }, [playersGroup, selectedTeam, playerNameSearch]);
  async function getScorecardData() {
    //const examsResponse = await TEAMS.GetScorecardExams(selectedTeam._id, playersGroup, playerNameSearch);
    const examsResponse: any = {
      status: true,
      data: {
        playersMap: {
          1: {firstName: 'first', lastName: 'one', picture: null},
          2: {firstName: 'second', lastName: 'two ', picture: null},
          3: {firstName: 'third', lastName: 'three', picture: null},
          4: {firstName: 'fourth', lastName: 'four', picture: null},
          5: {firstName: 'fifth', lastName: 'five ', picture: null},
          6: {firstName: 'sixth', lastName: 'six', picture: null},
        }, // key: player id; value: player data,
        records: [
          {
            playerId: 1,
            fatigue: {alert: 'Warning', test: 'ir rom', infoFatigue: ''},
            medicalAlerts: {lastFreshExamDay: 'isodate', reason: 'string'},
            armSoreness: {level: '1', location: 'back'},
            workloads: {date: null, latestAcRatio: 'float'},
            trainingAccountability: {lastTrainingDay: 'isodate', last7Days: 'float'},
            examAccountability: {lastFreshExams: 'isoDate', daysWithoutExams: 'int'},
            personalRecords: {date: 'isodate', category: 'string', situation: 'string', result: 'string'},
          },
          {
            playerId: 2,
            fatigue: {alert: 'Medical', test: 'er strength', infoFatigue: ''},
            medicalAlerts: {lastFreshExamDay: 'isodate', reason: 'string'},
            armSoreness: {level: '1', location: 'shoulder'},
            workloads: {date: null, latestAcRatio: 'float'},
            trainingAccountability: {lastTrainingDay: 'isodate', last7Days: 'float'},
            examAccountability: {lastFreshExams: 'isoDate', daysWithoutExams: 'int'},
            personalRecords: {date: 'isodate', category: 'string', situation: 'string', result: 'string'},
          },
          {
            playerId: 3,
            fatigue: {alert: 'Watch', test: 'er rom', infoFatigue: ''},
            medicalAlerts: {lastFreshExamDay: 'isodate', reason: 'string'},
            armSoreness: {location: 'eg'},
            workloads: {date: null, latestAcRatio: 0.5},
            trainingAccountability: {lastTrainingDay: 'isodate', last7Days: 'float'},
            examAccountability: {lastFreshExams: 'isoDate', daysWithoutExams: 'int'},
            personalRecords: {date: 'isodate', category: 'string', situation: 'string', result: 'string'},
          },
        ],
      },
    };
    if (examsResponse.status) {
      const newExams = examsResponse.data.records.map(item => {
        item.player = examsResponse.data.playersMap[item.playerId];
        item.player._id = item.playerId;
        return item;
      });

      useExams(newExams);
    }
  }
  return (
    <FluidContainer overflow={false}>
      <TablesWrapper>
        <TablesContainer>
          <ArmSoreness dataTableContent={exams} />
          <Fatigue dataTableContent={exams} />
          <Workloads dataTableContent={exams} />
          <TrainingAccountability dataTableContent={exams} />
          <ExamAccountability dataTableContent={exams} />
          <PersonalRecords dataTableContent={exams} />
          <MedicalAlerts dataTableContent={exams} />
        </TablesContainer>
      </TablesWrapper>
    </FluidContainer>
  );
};
